import { useTableActionContext } from '@aibees/elephant/context';
import { useFilterLabelsByOwnershipTab } from '@aibees/elephant/hooks/labels/use-label-ownership-tabs';
import { useMemo } from 'react';

interface UseDisabledRemoveParams {
  isLabel: boolean;
}

export function useDisabledRemove({
  isLabel,
}: UseDisabledRemoveParams): boolean {
  const {
    labels: globalLabels,
    lists: globalLists,
    tabValue,
  } = useTableActionContext();
  const filterByOwnershipTab = useFilterLabelsByOwnershipTab();

  return useMemo(() => {
    const array = isLabel ? globalLabels : globalLists;
    const filteredArray = filterByOwnershipTab(array, tabValue);

    return filteredArray.length === 0;
  }, [globalLabels, globalLists, isLabel, tabValue, filterByOwnershipTab]);
}
